import { render, staticRenderFns } from "./FormManageAccount.vue?vue&type=template&id=1bc9e04e&"
import script from "./FormManageAccount.vue?vue&type=script&lang=js&"
export * from "./FormManageAccount.vue?vue&type=script&lang=js&"
import style0 from "./FormManageAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports